import { render, staticRenderFns } from "./ModalFilaImpressao.vue?vue&type=template&id=3b7504ed"
import script from "./ModalFilaImpressao.vue?vue&type=script&lang=js"
export * from "./ModalFilaImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports